import { COLORS } from '../../../../utils/colors';

export const useScheduleStyles = () => {
  return {
    parent: {
      overflowY: 'auto',
      maxHeight: 'calc(100vh - 10rem)',
      display: 'flex',
      flexDirection: 'column',
      width: '47%',
      paddingRight: '1rem',
    },
    dateSpan: {
      fontSize: '0.875rem',
      fontWeight: 'bold',
      color: COLORS.MEDIUM_GRAY,
    },
    date: {
      marginRight: '0.5rem',
      fontSize: '1.875rem',
      fontWeight: 'bold',
      color: COLORS.TEXT,
    },
  };
};
